<template>
  <div class="notarization">
    <!-- 公证处 -->
    <div class="header">
      <div class="title">广西壮族自治区鹿寨县公证处</div>
      <ul>
        <li><span>业务范围：</span>国内公证业务</li>
        <li><span>主管机关：</span>鹿寨县司法局</li>
        <li><span>公证处主任：</span>赵得强</li>
        <li><span>公证员人数：</span>共3人</li>
        <li><span>公证员：</span>赵得强、张茜、韦雨辛</li>
        <li>
          <span>服务热线：</span><a href="tel:0772-6826051">0772-6826051</a>/<a
            href="tel:6817210"
            >6817210</a
          >/<a href="tel:6869091">6869091</a>
        </li>
        <li><span>地址：</span>广西柳州市鹿寨县鹿寨镇太和街30号</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.notarization {
  margin-top: 62px;
  height: calc(100vh - 62px);
  .header {
    padding: 15px 15px 20px;
    background-color: rgba(122, 191, 255, 0.14);
    border-radius: 4px;
    .title {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
    }
    ul {
      li {
        margin-top: 10px;
        line-height: 17px;
        font-size: 12px;
        color: #333;
        span {
          font-weight: 600;
        }
        a {
          color: #0882f3;
        }
      }
    }
  }
}
</style>
